import { PaymentFailed } from "components/web-checkout/payment-failed/payment-failed";
import { usePaymentFailed } from "hooks/pages/use-payment-failed/use-payment-failed";
import { PaymentMain } from "styles/pages/kredivo-payment.styles";

const Failed: React.FC = () => {
  const { onChatClick, onClickRetryPayment } = usePaymentFailed();

  return (
    <PaymentMain>
      <PaymentFailed
        onCTAClickAction={onClickRetryPayment}
        onChatClickAction={onChatClick}
      />
    </PaymentMain>
  );
};

export default Failed;
